import {Container, ItemBtn, ItemImg, ItemText, ItemTitle, List, ListItem, Wrap} from "./styled";
import {SubTitle} from "../../CummonComponents/SectionSubTitle/styled";
import {SectionTitle} from "../../CummonComponents/SectionTitle/SectionTitle";
import {useImageUrl} from "../../../queries";

const ProductItem = ({item}) => {
    const imageUrl = useImageUrl(item?.cover);

    return (
        <ListItem>
            {imageUrl && <ItemImg src={imageUrl}/>}
            <ItemTitle>{item?.title}</ItemTitle>
            <ItemText>{item?.short_description}</ItemText>
            <ItemBtn to='/products'>More information</ItemBtn>
        </ListItem>
    );
};

export const Products = ({data}) => {
    const productsTitle = data?.ppaanalyser_products_title || '';
    const productsDescription = data?.ppaanalyser_products_description || '';
    const products = data?.products || [];

    return (
        <Container>
            <Wrap>
                <SectionTitle>{productsTitle}</SectionTitle>
                <SubTitle>{productsDescription}</SubTitle>
                <List $customStyles={{
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                }}>
                    {products.map((product, index) => (
                        <ProductItem key={index} item={product.item}/>
                    ))}
                </List>
            </Wrap>
        </Container>
    )
}
